import React from "react";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { wishlist } = useAuth();
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-display text-3xl font-bold mb-6">My Wishlist</h1>
      {wishlist.length === 0 ? (
        <div className="text-center py-20"><Heart size={48} className="mx-auto text-slate-300 mb-3"/><div className="font-display text-xl font-semibold">Your wishlist is empty</div><Link data-testid="wish-shop-btn" to="/products" className="btn-primary-sf inline-flex mt-5 px-6 py-2.5 rounded-full text-sm font-semibold">Browse products</Link></div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {wishlist.map(p => <ProductCard key={p.product_id} p={p}/>)}
        </div>
      )}
    </main>
  );
}
